import {api} from "../../services";
import {route} from "preact-router";
import {useState} from "preact/compat";
import {useAppContext} from "../../contexts";
import {saveStockAlertIntent} from "../../utils";

export const useProductCard = (props) => {
    // Destructured props
    const {product} = props;

    // Controls the enabled state of the sold out alert button
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    // Retrieves the procedure to handle the application alert
    const {
        handleApplicationAlerts
    } = useAppContext();

    // Handles the isButtonDisabled state
    const handleIsButtonDisabled = (state) => {
        setIsButtonDisabled(prevState => {
            return typeof state !== "undefined" ? state : prevState;
        })
    }

    // Handles the "back in stock" alert feature
    const handleSoldOutClick = async () => {
        try {
            // Temporarily disables the button
            handleIsButtonDisabled(true);

            const {status, data} = await api.get(`/v1/product/stockalert?productId=${product.id}`);

            if (data.code === 1001) { // user is not logged in
                // Keeps both halves of the journey: where to come back to, and
                // the request itself, which the product page then completes.
                saveStockAlertIntent(product.id);

                const productPath = product.href ? product.href.split(".html")[0] : "";

                return route(`/entre?fallback=${encodeURIComponent(productPath)}`);
            }

            if (data.code !== 2001) { // success
                handleApplicationAlerts({
                    type: "error",
                    content: {
                        message:  data.message,
                        centered: true,
                        rounded:  false
                    }
                });

                return;
            }

            handleApplicationAlerts({
                type: "success",
                content: {
                    message:  data.message,
                    centered: true,
                    rounded:  false
                }
            });
        } catch (e) {
            console.error("Error while performing operation:", e);
        } finally {
            handleIsButtonDisabled(false);

            window.scrollTo({
                top: 0,
                behavior: 'smooth' // Suaviza a animação de scroll
            });
        }
    }

    return {
        isButtonDisabled,
        handleSoldOutClick
    }
}
